import React from 'react';

// CSS
import './IconOption.css';

class IconOption extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {

    let className = 'IconOption ButtonReset' + (this.props.highlight ? ' IconOption--Highlight' : '');

    return (
      <button 
        className={className}
        onClick={this.props.onClick}
        title={this.props.description}
      >
        <img src={this.props.icon} />
        <span>{this.props.title}</span>
      </button>
    );
  }
}

export default IconOption;
